import { render, staticRenderFns } from "./CustomStepper.vue?vue&type=template&id=1887443d&scoped=true"
import script from "./CustomStepper.vue?vue&type=script&lang=js"
export * from "./CustomStepper.vue?vue&type=script&lang=js"
import style0 from "./CustomStepper.vue?vue&type=style&index=0&id=1887443d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1887443d",
  null
  
)

export default component.exports